<template>
  <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="选择时间" prop="departureDate" label-width="110px">
        <el-date-picker v-model="departureDate" type="date" placeholder="请输入选择时间" value-format="yyyy-MM-dd"
          style="width:150px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="公交线路" prop="busLinesId" label-width="110px">
        <el-select style="width:160px;" v-model="busLinesId" @change="selectBusLinesIdChanged" placeholder="请选择公交线路">
          <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发车模版" prop="schedulingTemplateId" label-width="80px">
        <el-select style="width: 180px;" v-model="schedulingTemplateId" clearable placeholder="请选择发车模版">
          <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
            :label="item.DepartureTemplate">
            <span style="float: left">{{ item.DepartureTemplate }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
          v-if="!item.IsHide" @click="callFunc(item)">{{ item.name }}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getBusLinesListPage, getSchedulingTemplateListPage } from "../../api/api";

export default {
  name: "CreateSchedulingToolbar",
  data() {
    return {
      busLiness: [], //线路列表
      busLinesId: "", //线路ID
      departureDate: "", //选择时间
      schedulingTemplateList: [], //排班模版列表
      schedulingTemplateId: "", //排班模版表Id
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.departureDate = this.departureDate;
      item.busLinesId = this.busLinesId;
      item.schedulingTemplateId = this.schedulingTemplateId;
      this.$emit("callFunction", item); //将值传给父组件
    },
    setBusLinesId(busLinesId) {
      this.busLinesId = busLinesId;
    },
    setDepartureDate(departureDate) {
      this.departureDate = departureDate;
    },
    //设置默认日期
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
      //获取天，判断是否小于10，如果是在字符串前面拼接'0'
      let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString();
      //字符串拼接，开始时间，结束时间
      let departureDate = year + '-' + month + '-' + day;
      this.departureDate = departureDate; //将值设置给插件绑定的数据
    },
    selectBusLinesIdChanged(value) {
      this.schedulingTemplateList = [];
      this.schedulingTemplateId = "";
      if (value !== "") {
        this.getSchedulingTemplateList();
      }
    },
    getSchedulingTemplateList() {
      let para = {
        busLinesId: this.busLinesId,
        pageSize: 20
      };
      getSchedulingTemplateListPage(para).then(res => {
        this.schedulingTemplateList = res.data.response.data;
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLiness = res.data.response.data;
      this.busLinesId = this.busLiness.length > 0 ? this.busLiness[0].Id : "";
    });

    this.defaultDate();
  }
};
</script>